import { Card, Flex, Typography } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { Trans, useTranslation } from "react-i18next"

import Button from "../../../Components/Button"
import Icon from "../../../Icon"
import { openHideLink } from "../../../Utils/utils"

import s from "./PerkCard.module.less"

const { Text, Paragraph } = Typography

const PerkCard = ({ perk, disabled, maskPromocode }) => {
  const { t } = useTranslation()
  const { partner_name, partner_website, offer_details, description, url, promocode, logo_url } =
    perk

  return (
    <Card className={s.card} data-testid={`perk-card-${perk.id}`}>
      <Flex align="center" justify="space-between" gap={16} className={s.head}>
        <span className={s.logo}>
          {logo_url ? (
            <img src={logo_url} alt={partner_name} />
          ) : (
            <Text ellipsis strong>
              {partner_name}
            </Text>
          )}
        </span>
        <Text ellipsis={{ tooltip: partner_name }} type="secondary" className={s.domain}>
          {partner_website}
        </Text>
      </Flex>

      <div className={s.offer}>
        <Text className={s.offerText}>{offer_details}</Text>
      </div>

      <Paragraph ellipsis={{ rows: 4, tooltip: description }} type="secondary" className={s.desc}>
        {description}
      </Paragraph>

      <Button
        block
        size="large"
        className={cls(s.btn, "flex center")}
        onClick={() => !disabled && openHideLink(url, "_blank")}
        disabled={disabled}
        text={t("Get perk")}
        data-testid={`perk-card-get-btn-${perk.id}`}
      >
        <Icon type="open_link" />
      </Button>

      <Text type="secondary" className={s.note} data-testid={`perk-card-promocode-${perk.id}`}>
        {promocode ? (
          <Trans
            i18nKey="Enter promocode <strong>{{code}}</strong> during registration to redeem your perk."
            values={{ code: maskPromocode ? "********" : promocode }}
            components={{ strong: <strong /> }}
          />
        ) : (
          t("Visit link and sign up to redeem your perk.")
        )}
      </Text>
    </Card>
  )
}

PerkCard.propTypes = {
  perk: PropTypes.shape({
    id: PropTypes.string,
    partner_name: PropTypes.string,
    partner_website: PropTypes.string,
    offer_details: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    promocode: PropTypes.string,
    logo_url: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  maskPromocode: PropTypes.bool
}

export default PerkCard
